import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({standalone: true, name: 'roundDatePipe'})
export class RoundDatePipe implements PipeTransform
{
  constructor(private datePipe: DatePipe)
  {
  }

  transform(dateFrom: Date, dateTo: Date): string
  {
    if (dateFrom)
    {
      if (dateTo)
      {
        return this.datePipe.transform(dateFrom, 'dd.MM.') + ' - ' +
          this.datePipe.transform(dateTo, 'dd.MM.yy');
      }
      const date = new Date(dateFrom);
      if (date && (date.getHours() > 0 || date.getMinutes() > 0))
      {
        return this.datePipe.transform(date, 'dd.MM. HH:mm');
      }
      if (date)
      {
        return this.datePipe.transform(date, 'dd.MM.yy');
      }
    }
    return '';
  }
}
